import React from 'react';
import styled from 'styled-components';

import TecnologiesCard from '../components/TecnologiesCard';

// image imports
import dart from '../img/dart.png';
import flutter from '../img/flutter.png';
import javascript from '../img/javascript.png';
import database from '../img/database.png';
import docker from '../icons/docker.svg';
import reactLogo from '../icons/react.svg';
import typescript from '../icons/typescript.svg';
import node from '../icons/node.svg';
import kafka from '../img/kafka.png';
import spring from '../img/spring.png';
import aws from '../img/aws.png';
import go from '../img/golang.png';

function Technologies() {
  const H1 = styled.h1`
    color: whitesmoke;
    margin: 2rem auto;
    width: max-content;
  `;

  const H3 = styled.h3`
    color: #e2e2e2;
    margin: 0.25rem auto;
    width: max-content;
    @media (max-width: 1000px) { 
      width: 95%;
      text-align: center;
    }
  `;

  const Container = styled.div`
    width: 100%;
    height: max-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    justify-items: center;
    margin-bottom: 3%;
  `;

  const CardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 85%;
    height: max-content;
    margin: 5% auto;
    justify-content: space-evenly;
    gap: 50px 10%;
  `;

  return (
    <Container>
      <H1>Tecnologias</H1>
      <H3>
        Algumas tecnologias que aprendi até hoje na minha carreira de
        desenvolvedor!
      </H3>

      <CardContainer>
        <TecnologiesCard title="SQL / NoSQL" image={database} />
        <TecnologiesCard title="Dart" image={dart} />
        <TecnologiesCard title="Flutter" image={flutter} />
        <TecnologiesCard title="React JS/Native" image={reactLogo} />
        <TecnologiesCard title="Javascript" image={javascript} />
        <TecnologiesCard title="Typescript" image={typescript} />
        <TecnologiesCard title="Docker" image={docker} />
        <TecnologiesCard title="NodeJS" image={node} />
        <TecnologiesCard title="Kafka" image={kafka} />
        <TecnologiesCard title="Spring Boot" image={spring} />
        <TecnologiesCard title="Go" image={go} />
        <TecnologiesCard title="AWS" image={aws} />
      </CardContainer>
    </Container>
  );
}

export default Technologies;
